import { apiCall } from '../../../../coupon-common/src/utils';

const getCouponRangeList = () =>
  apiCall({
    url: '/users/coupon-range-list/',
    method: 'get',
  });

export default {
  getCouponRangeList,
};
